import { gql } from "@apollo/client";

const CREATE_USER_BANNER = gql`
  mutation CreateUserBanner(
    $imageUrl: String!
    $bannerId: String!
    $userId: String!
    $isVisible: Boolean
  ) {
    createUserBanner(
      input: {
        imageUrl: $imageUrl
        banner: $bannerId
        createdBy: $userId
        isVisible: $isVisible
      }
    ) {
      id
      banner {
        id
        name
        subtitle
      }
    }
  }
`;
export default CREATE_USER_BANNER;
